/**
 * File: App.tsx
 * Description: Root application component. Configures the theme provider and React Router route tree,
 * separating public FAQ routes (wrapped with CategoriesProvider) from the admin route.
 */
import { Routes, Route, Outlet } from 'react-router-dom';
import ThemeModeProvider from '@/context/theme/theme_mode_provider';
import AdminPage from '@/pages/admin/admin_page';
import MainPage from '@/pages/public/main_page';
import ArticlePage from '@/pages/public/article_page';
import CategoriesProvider from '@/context/public/categories_provider';
import CategoriesPage from './pages/public/category_page';

/**
 * Layout wrapper for all public-facing routes.
 * Mounts CategoriesProvider so that MainPage and ArticlePage share the same
 * fetched categories state without each page triggering its own request.
 *
 * @returns {JSX.Element}
 */
function PublicLayout() {
  return (
    <CategoriesProvider>
      <Outlet />
    </CategoriesProvider>
  );
}

/**
 * Root component of the application.
 * Wraps the entire route tree with ThemeModeProvider and defines two route groups:
 * public routes under PublicLayout ("/", "/articulo") and the admin route ("/admin").
 *
 * @returns {JSX.Element}
 */
function App() {
  return (
    <ThemeModeProvider>
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<MainPage />} />
          <Route path="/articulo" element={<ArticlePage />} />
          <Route path="/categoria" element={<CategoriesPage />} />
        </Route>
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </ThemeModeProvider>
  );
}

export default App;
